import { MultiTableSearch } from '@powerportalspro/react-fluent';

// The demo's accounts, contacts and opportunities, searched together and listed by name, ten at a
// time. Signed-in visitors can change what each table shows and save views of their own.

export function MultiTableSearchMainSample() {
  return <MultiTableSearch pageSize={10} allowSavedViews />;
}
